import { useSelector } from 'react-redux';
import * as dealTemplateSelectors from '@makemydeal/dr-dash-store/selectors/dealTemplateSelectors';
import type { UpdatingDealTemplate } from '@makemydeal/dr-dash-types';
import { ToastWithBackdropLoader } from '../../../../common/DataLoadingToast';
import { useRecentlyUpdatedTemplate } from '../../manageTemplate/hooks/useRecentlyUpdatedTemplate';

const titleGetters = {
    success: () => 'Template Successfully Updated',
    error: () => 'Failed to update template'
};
const messageGetters = {
    success: (name: string) => `We have successfully updated "<strong>${name}</strong>" template.`,
    error: () => 'This deal encountered an unforeseen issue, and the deal template could not be updated.'
};
export const LoadingToastForUpdatingTemplate = ({ suppressSuccess = false }: { suppressSuccess?: boolean }) => {
    const {
        isUpdated,
        isUpdating,
        isError: isUpdatingError,
        errorDetails: updatingErrorDetails,
        name: templateName
    } = useSelector(dealTemplateSelectors.getDealTemplateUpdatingStatus) as UpdatingDealTemplate;

    const { hasTemplateConflictError } = useRecentlyUpdatedTemplate();
    const isTemplateNameTaken = updatingErrorDetails?.name === 'TemplateNameConflictException';

    // Don't show error toast if conflict modal is shown
    const shouldShowError = isUpdatingError && !hasTemplateConflictError && !isTemplateNameTaken;

    return (
        <ToastWithBackdropLoader
            {...{ isLoading: isUpdating, isError: shouldShowError, isLoaded: !suppressSuccess && isUpdated }}
            getTitle={(type) => titleGetters[type]()}
            getMessage={(type) => messageGetters[type](templateName)}
        />
    );
};
